/**
 * AI Act image disclosure
 * Marks images whose alt text contains a KI marker, e.g.:
 *   - lp-gewinnspiel-ai
 *   - [KI]
 *
 * Compact "KI" badge (bottom-right). Click expands the disclosure text.
 */
(() => {
  const MARKERS = ["lp-gewinnspiel-ai", "[ki]"];
  const DISCLOSURE =
    "Dieses Bild wurde teilweise oder vollständig mit KI generiert";

  const hasMarker = (alt, src = "") => {
    const value = `${alt || ""} ${src || ""}`.toLowerCase();
    return MARKERS.some((marker) => value.includes(marker.toLowerCase()));
  };

  const findHost = (img) => {
    return (
      img.closest("image-banner") ||
      img.closest(".content-over-media") ||
      img.closest("picture")?.parentElement ||
      img.parentElement
    );
  };

  const bindToggle = (button) => {
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.dataset.emAiBound === "true") return;

    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const open = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", open ? "false" : "true");
      button.setAttribute(
        "aria-label",
        open ? "KI-Hinweis anzeigen" : "KI-Hinweis ausblenden"
      );
    });

    button.dataset.emAiBound = "true";
  };

  const createLabel = () => {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "em-ai-label";
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-label", "KI-Hinweis anzeigen");
    button.innerHTML =
      '<span class="em-ai-label__badge">KI</span>' +
      `<span class="em-ai-label__text">${DISCLOSURE}</span>`;
    bindToggle(button);
    return button;
  };

  const labelImage = (img) => {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.dataset.emAiLabeled === "true") return;
    if (!hasMarker(img.getAttribute("alt"), img.getAttribute("src"))) return;

    const host = findHost(img);
    if (!host) return;
    if (host.querySelector(":scope > .em-ai-label")) {
      img.dataset.emAiLabeled = "true";
      return;
    }

    host.classList.add("em-ai-label-host");
    host.appendChild(createLabel());
    img.dataset.emAiLabeled = "true";
  };

  const scan = (root = document) => {
    root.querySelectorAll("[data-em-ai-label], .em-ai-label").forEach(bindToggle);
    root.querySelectorAll("img[alt]").forEach(labelImage);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", (event) => {
    scan(event.target);
  });
})();
